// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__qI4_F","info":"PatientInfo_info__38n7J"};